let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let ProductSaleForm = require("./ProductSaleForm");

let numberOrZero = function(n){
	let q = parseFloat(n);
	return _.isNaN(q) ? 0 : q;
};

module.exports = dd.createClass({
	getInitialState(){
		return {editing_id: null};
	},
	__setEditingId(id){
		return _.bind(esUtils.wrapPreventDefault(function(){
			this.setState({editing_id: id});
		}), this);
	},
	render(){
		let {event, Displaylists, read_only} = this.props;
		let {editing_id} = this.state;

		let products_by_id = _.object(_.map(event.ProductSale, function(product){
			return [product.id, product];
		}));

		let rows = _.map(event.ProductSale, function(product){
			return dd.tr({
					key: product.id,
					className: read_only ? null : "editable",
					onClick: read_only ? null : this.__setEditingId(product.id)
				},
				dd.td(null, product.groupcode),
				dd.td(null, numberOrZero(product.qtysold)),
				dd.td(null, product.description),
				dd.td(null, esUtils.format_currency(numberOrZero(product.priceeach), 2))
			);
		}, this);

		return dd.div({className: "ProductSaleTable"},
			dd.table({className: "table table-responsive table-condensed" + (read_only ? "" : " table-hover")},
				dd.thead(null,
					dd.tr(null,
						dd.th({style: {width: 1}}, "Code"),
						dd.th({style: {width: 1}}, "Qty"),
						dd.th(null, "Description"),
						dd.th({style: {width: 1}}, "Price")
					)
				),
				dd.tbody(null,
					rows.length > 0 ? rows : dd.tr(null,
						dd.td({colSpan: 4, style: {textAlign: "center"}},
							"-- no products --"
						)
					)
				),
				rows.length > 0 ? dd.tfoot(null,
					dd.tr(null,
						dd.td({colSpan: 3}, "TOTAL ", dd.span({className: "text-muted"}, "(Qty x Price)")),
						dd.td(null, esUtils.format_currency(_.reduce(event.ProductSale, function(sum, product){
							return sum + (numberOrZero(product.qtysold) * numberOrZero(product.priceeach));
						}, 0), 2))
					)
				) : null
			),
			read_only ? null : dd.div(null,
				dd.button({className: "btn btn-default btn-sm pull-right", onClick: this.__setEditingId(0)},
					dd.i({className: "fa fa-plus"}), " Add Product"
				),
				dd.div({className: "clearfix"})
			),
			editing_id !== null ? Modal({
					title: editing_id > 0 ? "Edit Product" : "New Product",
					onClose: this.__setEditingId(null),
					buttons: []
				},
				ProductSaleForm({event, Displaylists, product: products_by_id[editing_id] || null, onClose: this.__setEditingId(null)})
			) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/ProductSaleTable.js